import React, { Component } from 'react'
import { Switch, Redirect, Route, withRouter } from 'react-router-dom'

import {
  CityManagerRoute,
  PrivateRoute,
  AdminRoute,
  ClientAdminRoute,
} from 'Config/Routing/auth'
import { ProfilePage } from 'Containers/Profile'
import ProfileEdit from 'Containers/Profile/ProfileEdit'
import CampaignsRouter from 'Config/Routing/CampaignsRouter'
import MissionRouter from 'Config/Routing/MissionRouter'
import { CityRouter } from 'Config/Routing/CityRouter'
import ClientRouter from 'Config/Routing/ClientRouter'
import SettingsRouter from 'Config/Routing/SettingsRouter'
import UserManagementRouter from 'Config/Routing/UserManagement'
import ClientRosters from 'Containers/ClientRosters'
import ChatRouter from 'Config/Routing/ChatRouter'

import { NotFound, NotAuthorised } from 'Components/Page'
import { PATHS } from 'Config/Routing/paths'
import { authorization } from '../../Module/Auth/Auth'
import CityAdd from './../../Containers/City/CityAdd'
import CityList from 'Containers/City/List'
import CountriesData from './../../Containers/City/DataHOCs/CountriesHOC'
import { ROLE_SPY } from '../../shared/constants'

/**
 * Check to which page user should be redirected after login
 * @returns {String}
 */
const getDefaultRoute = () => {
  const { role } = authorization.getUser()
  if (role === ROLE_SPY) {
    return PATHS.dashboard.cities
  }
  return PATHS.dashboard.campaigns + '?Status=Active'
}

class DashboardRouter extends Component {
  render() {
    return (
      <Switch>
        <Route exact path={this.props.match.url + PATHS.dashboard.cities}>
          <CityManagerRoute>
            <CityList {...this.props} />
          </CityManagerRoute>
        </Route>
        <Route
          exact
          path={
            this.props.match.url + PATHS.dashboard.cities + PATHS.cities.add
          }
        >
          <AdminRoute>
            <CountriesData>
              <CityAdd {...this.props} />
            </CountriesData>
          </AdminRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.dashboard.cities + '/:id'}>
          <CityManagerRoute>
            <CityRouter {...this.props} />
          </CityManagerRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.dashboard.clients}>
          <CityManagerRoute>
            <ClientRouter {...this.props} />
          </CityManagerRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.dashboard.mission}>
          <PrivateRoute>
            <MissionRouter />
          </PrivateRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.dashboard.chat}>
          <PrivateRoute>
            <ChatRouter />
          </PrivateRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.dashboard.campaigns}>
          <PrivateRoute isRestricted={authorization.isSpy()}>
            <CampaignsRouter />
          </PrivateRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.dashboard.rosters}>
          <PrivateRoute>
            <ClientRosters />
          </PrivateRoute>
        </Route>
        <Route exact path={this.props.match.url + PATHS.dashboard.profile}>
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        </Route>
        <Route exact path={this.props.match.url + PATHS.profile.edit}>
          <PrivateRoute>
            <ProfileEdit />
          </PrivateRoute>
        </Route>
        <Route exact path={this.props.match.url + PATHS.dashboard.notFound}>
          <PrivateRoute>
            <NotFound {...this.props} />
          </PrivateRoute>
        </Route>
        <Route
          exact
          path={this.props.match.url + PATHS.dashboard.notAuthorised}
        >
          <PrivateRoute>
            <NotAuthorised />
          </PrivateRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.dashboard.settings}>
          <CityManagerRoute>
            <SettingsRouter />
          </CityManagerRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.dashboard.userManagement}>
          <ClientAdminRoute>
            <UserManagementRouter />
          </ClientAdminRoute>
        </Route>
        <Redirect
          from={this.props.match.url}
          to={this.props.match.url + getDefaultRoute()}
        />
      </Switch>
    )
  }
}

export default withRouter(DashboardRouter)



// WEBPACK FOOTER //
// ./src/Config/Routing/DashboardRouter.js